import React, { Component } from 'react';

import Inputs from '../Edit/Inputs';
import StepButtons from './StepButtons';

class StepComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_logs_open: false,
        }
        this.openLog = this.openLog.bind(this);
    }

    openLog() {
        this.setState({
            is_logs_open: !this.state.is_logs_open,
        });
    }

    render() {
        const {
            is_logs_open,
        } = this.state;

        const {
            editComponent,
            step,
            contents,
            hide_outputs,
        } = this.props;

        const {
            is_completed,
            outputsFormatted,
            outputs,
            errors,
            timer,
            logs,
        } = contents;

        const {
            step: step_type,
            name: step_name,
            key: step_key,
            id,
        } = step;

        return (
            <div key={id} className={`component-wrapper ${logs ? (errors.length > 0 ? 'errors' : 'success') : ''}`}>
                <div className={is_completed ? "component completed" : "component"}>
                    <div className="component-tab"></div>
                    <div className="component-icon">
                        <span className="plus"></span>
                    </div>
                    <div className="component-label">
                        <h6>{step_type}</h6>
                        <h4>{step_name}</h4>

                        {!hide_outputs &&
                            <Inputs 
                                inputs={outputsFormatted}
                                is_output={true}
                            />
                        }

                        <StepButtons 
                            outputs={outputs}
                            hide_outputs={hide_outputs}
                            logs={logs}
                            errors={errors}
                            timer={timer}
                            openLog={this.openLog}
                        />

                    </div>

                    <div className="component-edit" onClick={() => editComponent(id)}>
                        <span className="icon edit"></span>
                    </div>
                </div>

                {logs && is_logs_open && 
                    <div className="show-logs-area">
                        <pre>
                            <code>
                                {JSON.stringify(logs, null, 4)}
                            </code>
                        </pre>
                    </div>
                }

            </div>
        )
    }
}

export default StepComplete;